import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["description", "name", "providerName", "certified", "imageSrcBig", "imageSrcSmall", "installCount", "installed", "linkMode", "listingHref", "metaBadges", "onLinkClick", "ribbonText", "ribbonUse"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HubspotCertificationIcon } from 'foundations-assets/icons/components/HubspotCertificationIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { StatusTag } from 'foundations-components/transitional/components/StatusTag';
import styled from 'foundations-theming/utils';
import { useLazyImage } from '../LazyImageProvider';
import { PolymorphicLink } from '../PolymorphicLink';
import { addInstallsMetaBadge } from '../utils/getInstallsMetaBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUnderlineOnHover = styled.div.withConfig({
  displayName: "EcosystemCardLarge__StyledUnderlineOnHover",
  componentId: "sc-1qsyixl-0"
})(["&:hover{text-decoration:underline;}"]);
export function EcosystemCardLarge(_ref) {
  let {
      description,
      name,
      providerName,
      certified = false,
      imageSrcBig,
      imageSrcSmall,
      installCount,
      installed,
      linkMode = 'default',
      listingHref,
      metaBadges = [],
      onLinkClick,
      ribbonText,
      ribbonUse
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const lazyImage = useLazyImage();
  const linkProps = {
    href: listingHref,
    linkMode,
    onClick: onLinkClick,
    use: 'unstyled'
  };
  return /*#__PURE__*/_jsxs(CardWrapper, Object.assign({
    compact: true
    // this is set to "ecosystem-app-card" to make for easy migration off our legacy components
    ,
    "data-test-id": "ecosystem-app-card"
  }, props, {
    children: [ribbonText && /*#__PURE__*/_jsx(Ribbon, {
      use: ribbonUse,
      position: "left",
      children: ribbonText
    }), /*#__PURE__*/_jsx(PolymorphicLink, Object.assign({}, linkProps, {
      tabIndex: -1,
      children: /*#__PURE__*/_jsxs(View, {
        backgroundColor: "fill-surface-recessed",
        blockSize: "164px",
        borderRadius: "200",
        margin: "600",
        marginBlockEnd: "500",
        overflow: "hidden",
        position: "relative",
        children: [imageSrcBig && /*#__PURE__*/_jsx(Image, {
          blockSize: "164px",
          inlineSize: "100%",
          loading: lazyImage,
          objectFit: "cover",
          src: imageSrcBig
        }), imageSrcSmall && /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          inset: "0",
          justifyContent: "center",
          position: "absolute",
          children: /*#__PURE__*/_jsx(Image, {
            blockSize: "100px",
            loading: lazyImage,
            src: imageSrcSmall
          })
        }), certified && /*#__PURE__*/_jsx(View, {
          position: "absolute",
          insetBlockStart: "0",
          insetInlineEnd: "0",
          padding: "200",
          children: /*#__PURE__*/_jsx(HubspotCertificationIcon, {
            color: "fill-brand-default",
            size: "600"
          })
        })]
      })
    })), /*#__PURE__*/_jsx(PolymorphicLink, Object.assign({}, linkProps, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        overflowWrap: "break-word",
        marginInline: "600",
        children: /*#__PURE__*/_jsx(StyledUnderlineOnHover, {
          children: name
        })
      })
    })), /*#__PURE__*/_jsxs(PolymorphicLink, Object.assign({}, linkProps, {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      paddingBlockStart: "100",
      paddingBlockEnd: "600",
      paddingInline: "600",
      tabIndex: -1,
      children: [/*#__PURE__*/_jsx(Text, {
        as: "small",
        color: "text-core-subtle",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "trellisEcosystem.appCard.providerName",
          options: {
            providerName
          }
        })
      }), /*#__PURE__*/_jsx(Text, {
        marginBlockStart: "200",
        marginBlockEnd: "400",
        children: description
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "end",
        gap: "200",
        marginBlockStart: "auto",
        children: [addInstallsMetaBadge(metaBadges, installed, installCount).map(metaBadge => /*#__PURE__*/_jsx(Badge, {
          use: "koala",
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "100",
            children: [metaBadge.label, metaBadge.icon]
          })
        }, metaBadge.label)), installed && /*#__PURE__*/_jsx(StatusTag, {
          use: "success",
          marginInlineStart: "100",
          marginBlockEnd: "50",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "trellisEcosystem.appCard.installed"
          })
        })]
      })]
    }))]
  }));
}